import { ReviewsWeeklyDigest } from '@app/model/review/digest/weekly/ReviewsWeeklyDigest';
import { ReviewsMonthlyDigest } from '@app/model/review/digest/montly/ReviewsMonthlyDigest';
import React from 'react';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import ReviewsPropertyInsightsObservationsFragment
	from '@app/site/secured/review-manager/fragment/property-overview/_insights/fragment/ReviewsPropertyInsightsObservationsFragment';

const ReviewsCompetitorInsightsKeyObservations: React.FunctionComponent<{
	digest: ReviewsWeeklyDigest | ReviewsMonthlyDigest
}> = ({ digest }) => {

	const { companyHotel } = useSelectedCompanyHotel();

	const positiveInsights = digest.insights.filter(insight => insight.insight.sentiment === 'POSITIVE' && insight.hotelId !== companyHotel.mainHotel.competitors[0].hotel.id);
	const negativeInsights = digest.insights.filter(insight => insight.insight.sentiment === 'NEGATIVE' && insight.hotelId !== companyHotel.mainHotel.competitors[0].hotel.id);


	return <div className="xl:col-span-12">
		<div className="px-3 mb-1"><h2 className="text-base font-semibold text-gray-900">Competitor Review Insights</h2>
		</div>
		<ReviewsPropertyInsightsObservationsFragment
			positiveInsights={positiveInsights}
			negativeInsights={negativeInsights}
		/>
	</div>;
};

export default ReviewsCompetitorInsightsKeyObservations;
